import React from "react";
import "../Styles/index.scss"

interface Props {
    tableHeader: any[];
    extraHeader?: boolean;
    textCenter?: boolean;
    type?: string;
    totalCgstAmount: number;
    totalIgstAmount: number;
    totalInvoiceValue: number;
    totalSgstAmount: number;
    totalTaxableValue: number;
    totalItcValue?:number;
}
const GstTotalHeader = ({ tableHeader = []
    , extraHeader,
    textCenter,
    type,
    totalCgstAmount,
    totalIgstAmount,
    totalInvoiceValue,
    totalSgstAmount,
    totalTaxableValue,
    totalItcValue
}: Props) => {
    return (
        <tr>
            {
                tableHeader.map((item, index) => {
                    if (item) {
                        if (item?.value === "invoice_date") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    TOTAL
                                </th>
                            )
                        }
                        else if (item?.value === "total_cgst_amount") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    {totalCgstAmount ? totalCgstAmount?.toFixed(2) : 0}
                                </th>
                            )
                        }
                        else if (item?.value === "total_igst_amount") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    {totalIgstAmount ? totalIgstAmount?.toFixed(2) : 0}
                                </th>
                            )
                        }
                        else if (item?.value === "total_sgst_amount") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    {totalSgstAmount ? totalSgstAmount?.toFixed(2) : 0}
                                </th>
                            )
                        }
                        else if (item?.value === "total_invoice_value") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    {totalInvoiceValue ? totalInvoiceValue?.toFixed(2) : 0}
                                </th>
                            )
                        }
                        else if (item?.value === "total_taxable_value") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    {totalTaxableValue ? totalTaxableValue?.toFixed(2) : 0}
                                </th>
                            )
                        }
                        else if (item?.value === "total_itc_amount") {
                            return (
                                <th className={`${textCenter ? 'text-center' : null} ${type ? 'gstr_head' : 'name'}  th-lg text-nowrap total-price`} style={{
                                    color: "#262a44", fontWeight: "600px",fontSize:"14px",
                                    lineHeight: "1.43rem"
                                }} key={item?.value}>
                                    {totalItcValue? totalItcValue?.toFixed(2) : 0}
                                </th>
                            )
                        }
                        else {
                            return (
                                <th>
                                </th>
                            )
                        }

                    } else {
                        return null
                    }
                })
            }
            {extraHeader && <th></th>}
        </tr>
    )
}

export default GstTotalHeader;
